import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { ownerApi, formatDetail } from "./api";

const OwnerAuthContext = createContext(null);

export function OwnerAuthProvider({ children }) {
  // null = still checking, false = not authed, object = authed
  const [owner, setOwner] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await ownerApi.get("/me");
      setOwner(data);
      return data;
    } catch {
      setOwner(false);
      return null;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await ownerApi.post("/login", { email, password });
      setOwner(data.owner);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await ownerApi.post("/logout"); } catch { /* ignore */ }
    setOwner(false);
  };

  return (
    <OwnerAuthContext.Provider value={{ owner, login, logout, refresh }}>
      {children}
    </OwnerAuthContext.Provider>
  );
}

export function useOwnerAuth() {
  const ctx = useContext(OwnerAuthContext);
  if (!ctx) throw new Error("useOwnerAuth must be used within OwnerAuthProvider");
  return ctx;
}
